import { useAuth } from '~/shared/api/auth-context';
import { type FunctionKey, type SectionHref, functionPermission, screenPermission } from './sections';

export function useCan<S extends SectionHref>(section: S, fn?: FunctionKey<S>): () => boolean {
  const { hasPermission } = useAuth();
  const permission = fn === undefined ? screenPermission(section) : functionPermission(section, fn);
  return () => permission !== undefined && hasPermission(permission);
}

export const NO_RIGHT_MESSAGE = 'Нет права на это действие';

export const requireRight =
  (can: () => boolean): (() => void) =>
  () => {
    if (!can()) throw new Error(NO_RIGHT_MESSAGE);
  };
